import React, { useContext } from 'react';

import { Context } from '@store/store';
import formatTimestamp from '@utils/formatTimestamp';

import {
  StyledBookmarkItem,
  StyledBookmarkItemPages,
  StyledBookmarkItemText,
  StyledBookmarkItemTimestamp,
} from './bookmark-item.styles';

const BookmarkItem = ({ page, text, ts }) => {
  const [state, dispatch] = useContext(Context);

  // Делает число четным для корректной работы
  const dualPageNum = Math.floor((page + 1) / 2) * 2; 

  return (
    <StyledBookmarkItem>
      <StyledBookmarkItemPages
        onClick={() => {
          dispatch({
            type: 'SET_CURRENT_PAGE',
            payload: page,
          });
        }}
      >
        {page === 0
          ? `Стр. ${page + 1}`
          : state.isSinglePageMode
          ? `Стр. ${page + 1}`
          : (page + 1) === state.pagesCount &&
                (state.pagesCount) % 2 === 0
          ? `Стр. ${page + 1}`
          : `Стр. ${dualPageNum}–${dualPageNum + 1}`
        }
      </StyledBookmarkItemPages>
      <StyledBookmarkItemText>{text}</StyledBookmarkItemText>
      <StyledBookmarkItemTimestamp>
        {formatTimestamp(ts)}
      </StyledBookmarkItemTimestamp>
    </StyledBookmarkItem>
  );
};

export default BookmarkItem;
